import { Dispatch } from 'redux';

import { actions } from '../../modules/Actions';
import { LOADING_TYPE } from '../../reducers/LoadingStatusReducer';
import { SORRY_MESSAGE_TYPE } from '../../reducers/SorryMessageReducer';
import { customerInfoAllApi } from '../../../external/CustomerInfoAllApi';

export interface FetchCustomerInfoAllKey {
  customerId: string;
}

/**
 * 初期化
 * @param dispatch
 */
export const clearCustomerInfoAll = (dispatch: Dispatch) => {
  dispatch(actions.fetchCustomerInfoAll.init());
};

/**
 * ステータスを更新しつつ、顧客全データを取得する
 * @param key API検索キー(customerId)
 * @param dispatch
 */
export const updateRefresh = (key: FetchCustomerInfoAllKey, dispatch: Dispatch) => {
  const refresh = async () => {
    fetchCustomerInfoAll(key, dispatch);
  };
  dispatch(actions.updateRefresh({ refresh }));
  refresh();
};

/**
 * サマリー表示データをマスクせずに取得する
 * @param key API検索キー(customerId)
 * @param dispatch
 */
export const updateRefreshNoMask = (key: FetchCustomerInfoAllKey, dispatch: Dispatch) => {
  const refresh = async () => {
    fetchCustomerInfoAll(key, dispatch, true);
  };
  dispatch(actions.updateRefresh({ refresh }));
  refresh();
};

const fetchCustomerInfoAll = async (key: FetchCustomerInfoAllKey, dispatch: Dispatch, noMask?: boolean) => {
  dispatch(actions.updateLoadingStatus.started(LOADING_TYPE.FETCH_CUSTOMER_INFO_ALL));
  try {
    const request = { customerId: key.customerId };
    const { result, customerInfoAllApiResult } = noMask ? await customerInfoAllApi(request, true) : await customerInfoAllApi(request);
    dispatch(actions.fetchCustomerInfoAll.fetch(customerInfoAllApiResult));
    dispatch(
      actions.updateLoadingStatus.done({
        params: LOADING_TYPE.FETCH_CUSTOMER_INFO_ALL,
        result: result,
      })
    );
  } catch (error) {
    dispatch(actions.updateSorryMessage(SORRY_MESSAGE_TYPE.SYSTEM_ERROR));
    dispatch(
      actions.updateLoadingStatus.failed({
        params: LOADING_TYPE.FETCH_CUSTOMER_INFO_ALL,
        error: {},
      })
    );
  }
};
